import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import api from '../api/axiosConfig';
import { useModal } from '../contexts/ModalContext';

const WorkerFormModal = ({ show, worker, onClose, onSuccess }) => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [memo, setMemo] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { showAlert } = useModal();


    // 맡은 점검은 계획에서 정한다. 여기서는 서버가 준 것을 그대로 보여준다.
    const assignedPlans = worker?.assignedPlans || [];

    useEffect(() => {
        if (!show) return;
        setName(worker?.name || '');
        setEmail(worker?.email || '');
        setMemo(worker?.memo || '');
    }, [show, worker]);




    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting) return;

        if (!name || !email) {
            showAlert('알림', '이름과 이메일은 필수 입력 항목입니다.', 'warning');
            return;
        }

        setIsSubmitting(true);
        try {
            const data = {
                name,
                email,
                memo: memo || undefined,
            };

            if (worker) {
                await api.patch(`/users/${worker.id}`, data);
                showAlert('성공', '사용자 정보가 수정되었습니다.', 'success');
            } else {
                await api.post('/users', data);
                showAlert('성공', '새 사용자가 등록되었습니다.', 'success');
            }

            onSuccess();
            onClose();
        } catch (error) {
            console.error('Error saving worker:', error);
            if (error.response?.data?.message) {
                showAlert('오류', `오류: ${error.response.data.message}`, 'danger');
            } else {
                showAlert('오류', '사용자 저장에 실패했습니다.', 'danger');
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal show={show} onHide={onClose} centered backdrop="static">
            <Modal.Header closeButton className="border-0 pb-0">
                <Modal.Title className="fw-bold">{worker ? '사용자 정보' : '사용자 등록'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-4">
                        <Form.Label className="fw-bold">이름 <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="입력하세요"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            className="py-2"
                        />
                    </Form.Group>

                    <Form.Group className="mb-4">
                        <Form.Label className="fw-bold">이메일 <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="이메일 형식에 맞게 입력하세요"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="py-2"
                        />
                        <Form.Text className="text-muted small mt-1 d-block">
                            <i className="bi bi-info-circle me-1"></i>
                            새 사용자의 초기 비밀번호는 <strong>0000</strong>으로 설정됩니다.
                        </Form.Text>
                    </Form.Group>

                    {/* 예전에는 여기서 담당 구역을 골랐다. 그 할당은 이제 점검에
                        아무 영향이 없다 -- 무엇을 점검하는지는 계획이 정한다.
                        고치는 곳을 한 곳으로 두고 여기서는 보여주기만 한다. */}
                    <Form.Group className="mb-4">
                        <Form.Label className="fw-bold">맡은 점검</Form.Label>
                        <div className="border rounded p-3 bg-light">
                            {assignedPlans.length === 0 ? (
                                <div className="text-muted small">맡은 점검이 없습니다.</div>
                            ) : (
                                assignedPlans.map((plan) => (
                                    <div
                                        key={plan.id}
                                        className="d-flex align-items-center gap-2 py-1"
                                    >
                                        <i className="bi bi-calendar-check text-primary small"></i>
                                        <span className={plan.status === 'PAUSED' ? 'text-muted' : ''}>
                                            {plan.name}
                                            {/* 멈춘 계획은 회차가 안 생긴다. 이걸 안 적으면
                                                '맡았는데 할 일이 없다' 가 설명되지 않는다. */}
                                            {plan.status === 'PAUSED' && ' (멈춤)'}
                                        </span>
                                    </div>
                                ))
                            )}
                        </div>
                    </Form.Group>

                    <Form.Group className="mb-4">
                        <Form.Label className="fw-bold">메모(선택)</Form.Label>
                        <div className="position-relative">
                            <Form.Control
                                as="textarea"
                                rows={4}
                                placeholder="이 사용자에 대한 메모"
                                value={memo}
                                onChange={(e) => setMemo(e.target.value)}
                                maxLength={100}
                                className="py-2"
                            />
                            <div className="text-end text-muted small mt-1">
                                {memo.length} / 100
                            </div>
                        </div>
                    </Form.Group>

                    <div className="d-flex gap-2 justify-content-end mt-4">
                        <Button variant="light" onClick={onClose} className="px-4 py-2 border">
                            취소
                        </Button>
                        <Button
                            variant="primary"
                            type="submit"
                            className="px-4 py-2 text-white"
                            disabled={isSubmitting || !name || !email}
                        >
                            {worker ? '저장' : '등록'}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default WorkerFormModal;
